import utils from "@/utilities/Utils";
import { SearchParameters } from "./SearchParameters";

export class OrderSearchParameters {
    searchParameters: SearchParameters = new SearchParameters();
    supplierID: number = 0;
    countryID: string = utils.emptyGuidValue;
}